<!-- 产品信息 -->
<template>
    <div v-if="componentsData.type == 18">
        <div class="overflow-hidden"
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <div class="fw-bold"
                :style="`
                    background: ${componentsData.content.title_bg_color}; color: ${componentsData.content.title_color}; font-size: ${componentsData.content.title_size}px;
                    padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px 6px ${componentsData.content.marginData.left}px;
                `"
            >
                {{ componentsData.content.title }}
            </div>
            <div
                :style="`
                    background: ${componentsData.content.text_bg_color}; color: ${componentsData.content.text_color}; font-size: ${componentsData.content.text_size}px;
                    padding: 6px ${componentsData.content.marginData.left}px ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;
                `"
            >
                <div>产品名称：{{ componentsData.content.text }}</div>
                <div>产品规格：{{ componentsData.content.text }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
}
</style>